module.exports = __webpack_public_path__ + "static/media/security.2e39d407.svg";